import { Flex, HStack, useDisclosure } from "@chakra-ui/react";
import { format } from "date-fns";
import CDS from "design-system";
import ProfileAvatar from "components/ProfileAvatar";
import { NewHireJourney } from "models/v2/newHireJourney";
import NewHireJourneyOptionMenu from "../NewHireJourneyOptionMenu";
import { UserProfileDrawer } from "../NewHireDetails";

interface HeaderIdentityCardProps {
  newHireJourney: NewHireJourney;
  canEditDetails?: boolean;
}

export default function HeaderIdentityCard({ newHireJourney, canEditDetails = false }: HeaderIdentityCardProps) {
  const profileDisclosure = useDisclosure();

  const subtitle = [
    newHireJourney.newHire?.title,
    newHireJourney.startDate ? `Started ${format(new Date(newHireJourney.startDate), "MMM d")}` : null,
    newHireJourney.newHire?.location,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <>
      <CDS.Card
        flex={{ base: "1 1 100%", lg: "1.5" }}
        minW="280px"
        padding="small"
        display="flex"
        alignItems="center"
      >
        <HStack spacing={4} align="center" w="100%">
          <ProfileAvatar user={newHireJourney.newHire} size="md" w="40px" h="40px" />
          <Flex direction="column" flex="1" minW={0} gap={0.5}>
            <CDS.Text18 fontWeight="600" color="content.primary" noOfLines={1}>
              {newHireJourney.newHire?.fullName}
            </CDS.Text18>
            {subtitle && (
              <CDS.Text14 color="content.tertiary" noOfLines={1}>
                {subtitle}
              </CDS.Text14>
            )}
          </Flex>
          <NewHireJourneyOptionMenu
            newHireJourney={newHireJourney}
            onOpenProfile={profileDisclosure.onOpen}
            canEdit={canEditDetails}
            size="sm"
          />
        </HStack>
      </CDS.Card>

      <UserProfileDrawer
        newHireJourney={newHireJourney}
        isOpen={profileDisclosure.isOpen}
        onClose={profileDisclosure.onClose}
        canEdit={canEditDetails}
      />
    </>
  );
}
